import React, {Component} from 'react'
import {TimelineMax,TweenLite,Linear,Sine,Expo,Power0,Power4} from 'gsap';
import Site, {SiteModifier_,withSite} from '../../utils/Site';

import {
  Link
} from 'react-router-dom';

import Scroller from '../Scroller'
import Base from '../BaseComponent'
import LifeAdvice from '../LifeAdvice'

class Welcome extends Component {

	open = false;
	scroller;

	componentDidMount = () => {

		this.refs.spacer.style.height = window.innerHeight+'px';

		let diff = (this.refs.logo.offsetHeight - this.refs.logoSymbol.offsetHeight)/2;
		this.refs.logoSymbol.style.marginTop = diff+'px';
		this.onInit(this.scroller);
	}

	click = () => {

		//return;

		let {scroller} = this;
		let _this = this;

		let dest = scroller.length;

		let progress = scroller.pos / scroller.length;

		if(progress > 0.3){
			_this.open();
		}else{

			let t = TweenLite.to(scroller,1.1,{pos:dest*0.45,ease:Expo.EaseOut,onUpdate: function(){

				scroller.update()

			},onComplete:function(){

				TweenLite.to(scroller,1.2,{delay:1,pos:dest,ease:Expo.EaseInOut,onUpdate: function(){

				scroller.update()

				},onComplete:function(){

					_this.open();

				}})

			}})
		}
		
		


	}
	open = () =>{

		this.props.site.modify('open');

	}

	initScroller = (scroller) => {

		this.scroller = scroller;

	}

	onInit = (scroller) => {

		const {tl,length} = scroller;
		const _this = this;

		
		


		let scrollDist = window.innerWidth * 10;
		let endScale = (window.innerWidth <= 745) ? 0.5 : 0.25;

		//scrollDist = 3000;
		scroller.setLength(scrollDist);

		//TweenLite.set(this.refs.logo,{scale:1.5});
		TweenLite.set(this.refs.shadow,{opacity:0.9});
		TweenLite.set(this.refs.message,{y:90,opacity:0});

		tl.to(this.refs.logo, 4, {top:0,scale:endScale,ease:Power0.easeNone});
		tl.to(this.refs.logoSymbol, 4, {marginTop:0,ease:Power0.easeNone},"-=4");

		

		tl.to(this.refs.message, 2, {opacity:1,ease:Power0.easeNone},"-=3.5");
		tl.to(this.refs.message, 4, {y:-200,ease:Power0.easeNone},"-=3.3");
		tl.to(this.refs.message, 2, {opacity:0},"-=1.5");

		tl.to(this.refs.shadow, 2, {top:'50%',ease:Power0.easeNone},"-=4");
		
		tl.to(this.refs.spacer, 4.6, {height:0, ease:Power0.easeNone,onComplete:function(){

			_this.props.site.modify('open');

		}},"-=2.5",);

		tl.to(this.refs.shadow, 4, {opacity:0,ease:Expo.easeIn},"-=5");
		tl.to(this.refs.shadow2, 4, {opacity:0,ease:Expo.easeIn},"-=5");
		



		setTimeout(()=>{
			if(scroller.pos == 0) _this.click();
		},3500)



	}

  render () {

    return (
    	
    	
    	<div className="Welcome-spacer" ref="spacer">

		      <Base {...this.props} family="Welcome" onClick={this.click}>
		      	
		        <div className="Welcome-logo" ref="logo">
		        	<Link to="/" ><div className="Logo Logo--welcome" ref="logoSymbol"  /></Link>
		        </div>
		        <div className="Welcome-message" ref="message">
		        	<LifeAdvice />
		        </div>
		        <div className="Welcome-shadow" ref="shadow" />

		        <div className="Welcome-shadow Welcome-shadow--2" ref="shadow2" />

		        <Scroller touchSensitivity={2} className="Welcome-scroller" onInit={this.initScroller} onResize={this.onInit} >
	    			<div/>
	    		</Scroller>

		      </Base>
      </div>
     
    
    )
  }
}

export default withSite(Welcome)


// WEBPACK FOOTER //
// ./src/js/components/Welcome/Welcome.jsx